import { DictionaryLaboratory, DictionaryLaboratorySchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "core/src/slices/etlData/slice/etlData.types";

export type PatchLaboratoryMappingRequest = {
	laboratoriesMapping: ItemMapping;
};

export type PatchLaboratoryMappingResponse = {
	dictionaryLaboratories: DictionaryLaboratory[];
};

export const patchLaboratoryMapping = createAppAsyncThunk<PatchLaboratoryMappingResponse, PatchLaboratoryMappingRequest>(
	"patchLaboratoryMapping",
	async ({ laboratoriesMapping }, { extra, getState, rejectWithValue }) => {

		const { extractLaboratories, dictionaryLaboratories } = getState().etlData;

		const tmpDictionaryLaboratories = [...dictionaryLaboratories];

		const extractLaboratory = extractLaboratories.find((extractLaboratory) => extractLaboratory.aw_laboratory_id === laboratoriesMapping.extractId.toString());
		const dictionnaryLaboratory = dictionaryLaboratories.find((dictionaryLaboratory) => dictionaryLaboratory.id === laboratoriesMapping.dicoId);

		if (
			dictionnaryLaboratory?.aw_laboratory_id === extractLaboratory?.aw_laboratory_id
			&& dictionnaryLaboratory?.libelle === extractLaboratory?.libelle
		) {
			return rejectWithValue("No changes");
		}

		if (extractLaboratory) {
			const dictionaryLaboratoriesUpdated = await extra.etlClient.update(
				DictionaryLaboratorySchema,
				laboratoriesMapping.dicoId,
				{
					aw_laboratory_id: extractLaboratory?.aw_laboratory_id,
				},
			);

			if (dictionaryLaboratoriesUpdated) {
				tmpDictionaryLaboratories.splice(
					tmpDictionaryLaboratories.findIndex((laboratory) => laboratory.id === laboratoriesMapping.dicoId),
					1,
					dictionaryLaboratoriesUpdated.data
				);
			}

		}

		return {
			dictionaryLaboratories: tmpDictionaryLaboratories
		}
	}
);
